/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { enumeration as o } from "../../core/accessorSupport/decorators/enumeration.js";
import { subclass as r } from "../../core/accessorSupport/decorators/subclass.js";
import i from "./DeviceLocationFeed.js";
import s from "./FeatureFenceParameters.js";
import p from "./Geotrigger.js";
import n from "./GeotriggerNotificationOptions.js";
import { fenceNotificationRuleKebabDict as c, enterExitRuleKebabDict as a, feedAccuracyModeKebabDict as u } from "./support/typeUtils.js";
let d = class extends p {
  constructor(e) {
    super(e), this.enterExitRule = "enter-contains-and-exit-does-not-intersect", this.feed = null, this.feedAccuracyMode = "use-geometry", this.fenceNotificationRule = null, this.fenceParameters = null, this.name = null, this.notificationOptions = null, this.type = "fence";
  }
};
e([o(a)], d.prototype, "enterExitRule", void 0), e([t({
  type: i,
  json: {
    write: {
      isRequired: !0
    }
  }
})], d.prototype, "feed", void 0), e([o(u)], d.prototype, "feedAccuracyMode", void 0), e([t({
  type: c.apiValues,
  json: {
    type: c.jsonValues,
    read: c.read,
    write: {
      writer: c.write,
      isRequired: !0
    }
  }
})], d.prototype, "fenceNotificationRule", void 0), e([t({
  type: s,
  json: {
    write: {
      isRequired: !0
    }
  }
})], d.prototype, "fenceParameters", void 0), e([t({
  type: String,
  json: {
    write: !0
  }
})], d.prototype, "name", void 0), e([t({
  type: n,
  json: {
    write: !0
  }
})], d.prototype, "notificationOptions", void 0), e([o({
  fence: "fence"
}, {
  readOnly: !0
})], d.prototype, "type", void 0), d = e([r("esri.webdoc.geotriggersInfo.FenceGeotrigger")], d);
const m = d;
export { m as default };